import React, { useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    CircularProgress,
    FormControlLabel,
    Radio,
    RadioGroup,
    IconButton,
    ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CATEGORIES } from "../../utils/constants";
import GeoLocation from "../../components/inputs/Geolocation";
import { toTitleSpaceCase } from "../../utils/main";
import moment from "moment";
import { Close } from "@mui/icons-material";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { getCountryApi } from "../../apis/country.api";
import CustomInput from "../../components/inputs/CustomInputs";
import { getStateApi } from "../../apis/state.api";
import { getCityApi } from "../../apis/city.api";

const FilterSelection = ({
    products,
    source,
    filters,
    setFilters,
    loading,
}) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    console.log("object filters", filters);
    const accordionStyle = {
        disableGutters: true,
        square: true,
        sx: {
            "&:before": { display: "none" },
            boxShadow: "none",
            borderBottom: "1px solid #e0e0e0",
            "& .MuiAccordionSummary-root": {
                minHeight: "40px !important",
            },
            "& .MuiAccordionSummary-content": {
                margin: "4px 0",
            },
            "& .MuiAccordionDetails-root": {
                padding: "4px 8px",
            },
        },
    };

    return (
        <Box
            style={{
                height: "98%",
                // width: 200,
                borderRight: "1px solid #e0e0e0",
                padding: 8,
            }}
        >
            <Box sx={{ marginBottom: 2, display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start" }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: "#1D013B",
                            // padding: 2,
                            fontFamily: "Public Sans",

                        }}
                    >
                        Filters
                    </Typography>
                </Box>
                <Box
                    onClick={() => setFilters({
                        product_id: "",
                        source_id: "",
                        country: "",
                        state: "",
                        city: "",
                        category: "",
                        isDashboard: true,
                        categories: "",
                        date: {
                            start: moment().subtract(1, 'year'),
                            end: moment().subtract(0, 'year')
                        }
                    })}
                    sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
                >
                    <Typography
                        variant="body2"
                        sx={{
                            // fontWeight: 400,
                            color: "#1D013B",
                            borderBottom: "1px solid #1D013B",
                            fontFamily: "Public Sans",
                            cursor: "pointer",
                        }}
                    >
                        Clear
                    </Typography>
                </Box>

            </Box>

            {/* Categories */}
            <Accordion
                expanded={expanded === "categories"}
                onChange={handleChange("categories")}
                {...accordionStyle}
            >
                <AccordionSummary expandIcon={
                    filters.category ? (
                        <Box sx={{ display: "flex", alignItems: "center", }}>
                            {expanded === "categories" && <ExpandMoreIcon />}
                            <IconButton onClick={() => setFilters({
                                ...filters,
                                category: "",
                                categories: "",
                            })}> <Close fontSize="small" /></IconButton>
                            {expanded !== "categories" && <ExpandMoreIcon />}
                        </Box>
                    ) : (
                        <ExpandMoreIcon />
                    )
                }>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            color: "#1D013B",
                            fontFamily: "Public Sans",
                        }}
                    >
                        {filters.category
                            ? toTitleSpaceCase(filters.category)
                            : "Categories"}
                    </Typography>

                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, pl: 1 }}>
                    <RadioGroup
                        value={filters.category}
                        onChange={(e) => {
                            console.log("object e.target.value", e);
                            setFilters((prev) => ({
                                ...prev,
                                categories: CATEGORIES[e.target.value],
                                category: e.target.value,
                                product_id: "",
                            }));
                        }}
                    >
                        {Object.keys(CATEGORIES).map((key) => (
                            <FormControlLabel
                                key={CATEGORIES[key]}
                                value={key}
                                control={
                                    <Radio
                                        sx={{
                                            color: "#1D013B",
                                            "&.Mui-checked": { color: "#1D013B" },
                                            p: 0.5,
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontFamily: "Public Sans",
                                            color: "#1D013B",
                                            fontWeight: 500,
                                            fontSize: "13px",
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {toTitleSpaceCase(key.replace(/_/g, " "))}
                                    </Typography>
                                }
                                sx={{
                                    m: 0,
                                    gap: 0.5,
                                    alignItems: "center",
                                    display: "flex",
                                }}
                            />
                        ))}
                    </RadioGroup>
                </AccordionDetails>
            </Accordion>

            {/* Product Name */}
            <Accordion
                expanded={expanded === "productName"}
                onChange={handleChange("productName")}
                {...accordionStyle}
            >
                <AccordionSummary expandIcon={
                    filters.product_id ? (
                        <Box sx={{ display: "flex", alignItems: "center", }}>
                            {expanded === "productName" && <ExpandMoreIcon />}
                            <IconButton onClick={() => setFilters({
                                ...filters,
                                product_id: "",
                            })}> <Close fontSize="small" /></IconButton>
                            {expanded !== "productName" && <ExpandMoreIcon />}
                        </Box>
                    ) : (
                        <ExpandMoreIcon />
                    )
                }>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            color: "#1D013B",
                            fontFamily: "Public Sans",
                        }}
                    >
                        {filters.product_id
                            ? toTitleSpaceCase(
                                products?.find((p) => p._id === filters.product_id)
                                    ?.name || ""
                            )
                            : "Product Name"}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                    {loading ? (
                        <CircularProgress size={24} />
                    ) : (
                        <RadioGroup
                            value={filters.product_id}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    product_id: e.target.value,
                                    productName: products?.find((p) => p._id === e.target.value)?.name || "",
                                }))
                            }
                        >
                            {products?.map((product) => (
                                <FormControlLabel
                                    key={product._id || product.name}
                                    value={product._id}
                                    control={
                                        <Radio
                                            sx={{
                                                color: "#1D013B",
                                                "&.Mui-checked": { color: "#1D013B" },
                                                p: 0.5,
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontFamily: "Public Sans",
                                                color: "#1D013B",
                                                fontWeight: 500,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {toTitleSpaceCase(product.name)}
                                        </Typography>
                                    }
                                    sx={{
                                        m: 0,
                                        gap: 0.5,
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}
                                />
                            ))}
                        </RadioGroup>
                    )}
                </AccordionDetails>
            </Accordion>

            {/* Purchase From */}
            <Accordion
                expanded={expanded === "purchaseFrom"}
                onChange={handleChange("purchaseFrom")}
                {...accordionStyle}
            >
                <AccordionSummary expandIcon={
                    filters.source_id ? (
                        <Box sx={{ display: "flex", alignItems: "center", }}>
                            {expanded === "purchaseFrom" && <ExpandMoreIcon />}
                            <IconButton onClick={() => setFilters({
                                ...filters,
                                source_id: "",
                            })}> <Close fontSize="small" /></IconButton>
                            {expanded !== "purchaseFrom" && <ExpandMoreIcon />}
                        </Box>
                    ) : (
                        <ExpandMoreIcon />
                    )
                }>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            color: "#1D013B",
                            fontFamily: "Public Sans",
                        }}
                    >
                        {filters.source_id
                            ? toTitleSpaceCase(
                                source?.find((s) => s._id === filters.source_id)
                                    ?.title || ""
                            )
                            : "Purchase From"}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0 }}>
                    {loading ? (
                        <CircularProgress size={24} />
                    ) : (
                        <RadioGroup
                            value={filters.source_id}
                            onChange={(e) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    source_id: e.target.value,
                                }))
                            }
                        >
                            {source?.map((source) => (
                                <FormControlLabel
                                    key={source._id || source.title}
                                    value={source._id}
                                    control={
                                        <Radio
                                            sx={{
                                                color: "#1D013B",
                                                "&.Mui-checked": { color: "#1D013B" },
                                                p: 0.5,
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontFamily: "Public Sans",
                                                color: "#1D013B",
                                                fontWeight: 500,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {toTitleSpaceCase(source.title)}
                                        </Typography>
                                    }
                                    sx={{
                                        m: 0,
                                        gap: 0.5,
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "row",
                                    }}
                                />
                            ))}
                        </RadioGroup>
                    )}
                </AccordionDetails>
            </Accordion>

            {/* Location */}
            <Accordion
                expanded={expanded === "location"}
                onChange={handleChange("location")}
                {...accordionStyle}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            color: "#1D013B",
                            fontFamily: "Public Sans",
                        }}
                    >
                        Location
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1
                        }}
                    >
                        <AsyncDropDown
                            key={filters.country}
                            // disabled={user.data.role !== USER_ROLES.ADMIN}
                            value={filters.country ? { _id: filters.country, name: filters.countryName } : null}
                            lazyFun={async (para) => await getCountryApi({ ...para, allStatus: true })}
                            OptionComponent={({ option, ...rest }) => {
                                return <ListItem {...rest}>{option.name}</ListItem >
                            }}
                            onChange={async (changedVal) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    country: changedVal?._id || "",
                                    countryName: changedVal?.name || "",
                                    state: "",
                                    stateName: "",
                                    city: "",
                                    cityName: "",
                                }));
                            }}
                            titleKey={'name'}
                            valueKey={"_id"}
                            InputComponent={(params) => <CustomInput placeholder={"Select Country"} label={"Country"} {...params} margin="none" />}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1
                        }}
                    >
                        <AsyncDropDown
                            key={filters.country}
                            disabled={!filters.country}
                            value={filters.country && filters.state ? { _id: filters.state, name: filters.stateName } : null}
                            lazyFun={async (para) => await getStateApi({ ...para, allStatus: true, country: filters.country })}
                            OptionComponent={({ option, ...rest }) => {
                                return <ListItem {...rest}>{option.name}</ListItem >
                            }}
                            onChange={async (changedVal) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    state: changedVal?._id || "",
                                    stateName: changedVal?.name || "",
                                    city: "",
                                    cityName: "",
                                }));
                            }}
                            titleKey={'name'}
                            valueKey={"_id"}
                            InputComponent={(params) => <CustomInput placeholder={"Select State"} label={"State"} {...params} margin="none" />}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1
                        }}
                    >
                        <AsyncDropDown
                            key={filters.state}
                            disabled={!(filters.country && filters.state)}
                            value={filters.country && filters.state && filters.city ? { _id: filters.city, name: filters.cityName } : null}
                            lazyFun={async (para) => await getCityApi({ ...para, allStatus: true, state: filters.state })}
                            OptionComponent={({ option, ...rest }) => {
                                return <ListItem {...rest}>{option.name}</ListItem >
                            }}
                            onChange={async (changedVal) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    city: changedVal?._id || "",
                                    cityName: changedVal?.name || "",
                                }));
                            }}
                            titleKey={'name'}
                            valueKey={"_id"}
                            InputComponent={(params) => <CustomInput placeholder={"Select City"} label={"City"} {...params} margin="none" />}
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default FilterSelection;
